import { Injectable } from '@angular/core';
import { AppInjector } from '../utils/services/set-app-injector';
import { LoadersService } from '../utils/loaders/loaders.service';
import { LoaderActions } from '../utils/loaders/loader-actions.enum';
import { ModalLoaderData } from '../utils/loaders/modal-loader.service';
import { LoaderManagement } from '../utils/loaders/loader-management';
import { CommonModalService } from '../utils/modals/common-modal.service';
import { CommonModalTemplatesEnum } from '../utils/modals/common-modal-templates.enum';

@Injectable ()
export class LogoutModalService {
  private endpoint: any;
  private loadersService: LoadersService;

  constructor(
    private commonModalService: CommonModalService
  ) {

    this.endpoint = AppInjector.get('Endpoint');
    this.loadersService = AppInjector.get(LoadersService);
  }

  public showModal(): void {
    const modalData = {
      templateName: CommonModalTemplatesEnum.LOGOUT_MODAL,
      themeResourcePath: (window['themeResourcePath']) ? window['themeResourcePath'] : '',
      onLogout: ($event: MouseEvent) => {
        $event.preventDefault();

        this.logout();
      },
    };

    this.commonModalService.setData(modalData);
  }

  public logout(): void {
    setTimeout( () => {
      this.startLoader();
    }, 800);

    this.endpoint('newCustomer.logout')
      .run()
      .then(() => {
        this.stopLoader()
          .runAfterDelay(() => {
            this.processLogoutResponse();
          });
      })
      .catch(() => {
        this.stopLoader();
        this.showModal();
      });
  }

  private processLogoutResponse(): void {
    window.location.href = window['PORTAL_URL'];
  }

  private startLoader(): void {
    const LOADER_TITLE = 'Proszę czekaj...';

    this.loadersService.start(
      LoaderActions.MODAL_LOADER,
      new ModalLoaderData(
        LOADER_TITLE,
        true
      ),
      true
    );
  }

  private stopLoader(): LoaderManagement {
    return this.loadersService.stop(LoaderActions.MODAL_LOADER);
  }
}
